export default __webpack_public_path__ + "static/media/fa-upload.7b5e7dd2.svg";